export default "__VITE_ASSET__CMvKKUtD__"